import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users } from "lucide-react";
import http from "@/api";
import { useApp } from "@/context";

export default function LiveBanner() {
  const { lang } = useApp();
  const [snap, setSnap] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => http.get("/live/current")
      .then(({ data }) => { if (alive) setSnap(data); })
      .catch(() => {});
    load();
    const iv = setInterval(load, 60_000);
    return () => { alive = false; clearInterval(iv); };
  }, []);

  if (!snap?.live) return null;
  const ar = lang === "ar";
  return (
    <Link to="/live" data-testid="home-live-banner"
          className="flex items-center gap-3 rounded-2xl px-4 py-3 text-white overflow-hidden relative"
          style={{ background: "linear-gradient(100deg, #7a0d1e, #1a0206 70%)" }}>
      <div className="relative flex-shrink-0">
        <img src="/live/host_closed.jpg" alt="المقدم"
             className="w-11 h-11 rounded-full object-cover object-top ring-2 ring-red-500" />
        <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 bg-red-600 text-[8px] font-black px-1.5 py-0.5 rounded-full tracking-wider">
          LIVE
        </span>
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[13px] font-bold flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" />
          {ar ? `بث مباشر الآن — ${snap.persona?.name || "راشد"} يعرض منتجات مختارة` : "Live now — picks are being presented"}
        </div>
        <div className="text-[11px] text-white/70 flex items-center gap-1 mt-0.5">
          <Users size={11} /> {snap.viewers || 0} {ar ? "يشاهدون الآن" : "watching"}
        </div>
      </div>
      <span className="flex-shrink-0 text-[12px] font-black bg-white text-black rounded-full px-4 py-2">
        {ar ? "شاهد" : "Watch"}
      </span>
    </Link>
  );
}
